'use client';

import { Button, Icon } from '@repo/ui';

interface ClientInvoicesHeaderProps {
  /** Name of the client whose invoices are being viewed */
  clientName: string;
  /** Callback when "Back to Clients" button is clicked */
  onBackToClients: () => void;
  /** Render prop for toolbar - allows parent to inject custom toolbar */
  renderToolbar: () => React.ReactNode;
}

/**
 * Header component for invoice detail (drilldown) views.
 * Displays a back button, client name, and an injected toolbar.
 */
export function ClientInvoicesHeader({
  clientName,
  onBackToClients,
  renderToolbar,
}: ClientInvoicesHeaderProps) {
  return (
    <div className="flex flex-col justify-between w-full gap-1">
      {/* Back Button + Client Name */}
      <div className="flex justify-start items-center gap-4">
        <Button
          variant="ghost"
          className="flex items-center gap-1 font-medium text-xtnd-dark dark:text-xtnd-light"
          onClick={onBackToClients}
        >
          <Icon name="FaAngleLeft" />
          Back to Clients
        </Button>
        <div className="text-sm font-medium text-xtnd-dark dark:text-xtnd-light">
          {clientName} - Invoices
        </div>
      </div>

      {/* Toolbar Row */}
      <div className="flex justify-between gap-4 mt-2">
        <div className="w-full">{renderToolbar()}</div>
      </div>
    </div>
  );
}
